import LayoutFixHome from "../components/LayoutFixHome";
import { Box, Typography } from "@mui/material";
import { ClientRegistration } from "../components/ClientRegistration";
import { RoutesConfig } from "../router/types";
import { useNavigate } from "react-router-dom";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";

const RegistroCliente = () => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(RoutesConfig.CADASTRARUSUARIO.path);
  };

  return (
    <>
      <LayoutFixHome>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginBottom: "29px",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
            }}
          >
            <div onClick={handleBack}>
              <ExpandCircleDownOutlinedIcon
                style={{ transform: "rotate(-270deg)" }}
                sx={{ color: "#0A0C33", height: "30px", width: "30px" }}
              />
            </div>
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold", color: "#0A0C33" }}
            >
              Cadastro de Cliente
            </Typography>
          </Box>
        </Box>
        <ClientRegistration />
      </LayoutFixHome>
    </>
  );
};

export default RegistroCliente;
